import { ZUid, zUid } from "src/types/zUid";
import { z } from "zod";

export enum ZNotifyType {
  push = 0,
  email = 1,
  all = 2,
}
export const zNotifyType = z.nativeEnum(ZNotifyType);

export const zNotifyTemplate = z.object({
  id: zUid,
  stateId: zUid,
  roleIds: zUid.array(),
  messageType: zNotifyType,
  templateText: z.record(zUid, z.string()),
  active: z.boolean(),
});

export type ZNotifyTemplate = z.infer<typeof zNotifyTemplate>;

export type ZNotifyTemplateToSave = Omit<ZNotifyTemplate, "id"> & {
  id?: ZUid;
};
